import "react-native-reanimated";
import { WidgetPos } from "../types";
import { getPositionOrdinal, getSizeOrdinal } from "./getPositionOrdinal";

export function getPositionsBetween(
  fromId: string,
  toTarget: WidgetPos,
  positions: WidgetPos[]
) {
  "worklet";
  const from = positions.find((p) => p.id === fromId);
  if (!from) {
    throw new Error("getPositionsBetween item from not found");
  }

  const fromOrdinal = getPositionOrdinal(from);
  const toOrdinal = getPositionOrdinal(toTarget);
  const sizeOrdinal = getSizeOrdinal(toTarget);

  return positions.filter((position) => {
    if (position.id === fromId) {
      return false;
    }

    const positionOrdinal = getPositionOrdinal(position);
    const positionSizeOrdinal = getSizeOrdinal(position);
    if (
      fromOrdinal > toOrdinal &&
      positionOrdinal < fromOrdinal &&
      positionOrdinal + positionSizeOrdinal >= toOrdinal
    ) {
      return true;
    }

    if (
      fromOrdinal < toOrdinal &&
      positionOrdinal > fromOrdinal &&
      positionOrdinal <= toOrdinal + sizeOrdinal
    ) {
      return true;
    }
  });
}
